import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnChanges, OnDestroy, OnInit, Output
} from '@angular/core';

import { DeviceService } from '../../_services/device.service';
import { IconSizeEnum } from '../../_enums/icon.enum';
import { ILink } from '../../_interfaces/link.interface';
import { PositionEnum } from '../../_enums/position.enum';
import { SdIconComponent } from '../icons/icon/icon.component';
import { SdLibConfig } from '../../sd-lib-config';
import { SdLinkComponent } from '../links/link/link.component';
import { SdListComponent } from '../lists/list/list.component';
import { SdThemeComponent } from '../abstract/theme/theme.component';

@Component({
  selector: 'sd-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdListComponent,
    SdLinkComponent,
    SdIconComponent,
    RouterLink,
    TranslateModule
  ]
})
export class SdBreadcrumbComponent extends SdThemeComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  breadcrumb: ILink[];

  @Input()
  separator = 'icon-arrow-right';

  @Input()
  class: string; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.backHomeMobile && this.isDevice$ ? 'is-back-home' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  @Output()
  clickNavigation = new EventEmitter<ILink>();

  backHomeMobile: boolean;
  deviceSubscription: Subscription;
  isDevice$: boolean;
  positionEnum = PositionEnum;
  iconSize = IconSizeEnum;

  constructor(
    private cdRef: ChangeDetectorRef,
    private sdLibConfig: SdLibConfig,
    private deviceService: DeviceService
  ) {
    super();
    this.backHomeMobile = this.sdLibConfig.get().breadcrumbMobileBackHome;
  }

  ngOnInit() {
    this.deviceSubscription = this.deviceService.isDevice.subscribe((x) => {
      this.isDevice$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnChanges(changes?) {
    super.ngOnChanges(changes);
    this.backHomeMobile = this.sdLibConfig.get(this.brand).breadcrumbMobileBackHome;
  }

  ngOnDestroy() {
    this.deviceSubscription?.unsubscribe();
  }

  onClickLink(link: ILink) {
    this.clickNavigation.emit(link);
  }
}
